module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0029.jpg?v=7b64f8f0";